module.exports = {
          srcSet: __webpack_public_path__ + "601cc0c8619e2bc24b43cb0588bdc6d7-708.png"+" 708w",
          images:[ {path: __webpack_public_path__ + "601cc0c8619e2bc24b43cb0588bdc6d7-708.png",width: 708,height: 974}],
          src: __webpack_public_path__ + "601cc0c8619e2bc24b43cb0588bdc6d7-708.png",
          toString:function(){return __webpack_public_path__ + "601cc0c8619e2bc24b43cb0588bdc6d7-708.png"},
          
          width: 708,
          height: 974
        }